import { ChangeDetectionStrategy, Component, OnInit, signal } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ConfigService } from "src/app/servicios/config/config.service";
import { KebabCasePipe } from "../../../pipes/kebab-case.pipe";
import { NoticiasService } from "../../../servicios/noticias/noticias.service";
import { NgOptimizedImage, NgFor, NgIf } from "@angular/common";
import { Subscription } from "rxjs";
import { DeviceService } from "@src/app/servicios/device/device.service";

@Component({
  selector: "app-bloque-carta-director",
  templateUrl: "./bloque-carta-director.component.html",
  styleUrls: ["./bloque-carta-director.component.css"],
  imports: [RouterLink, KebabCasePipe, NgOptimizedImage, NgFor, NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BloqueCartaDirectorComponent implements OnInit {
  noticias = signal([]);
  constantesGlobales;
  isMobile = signal<boolean | null>(null);
  isMobileSub: Subscription;

  constructor(
    private readonly noticiasService: NoticiasService,
    private readonly configService: ConfigService,
    private readonly deviceService: DeviceService,
  ) {
    this.deviceService.isMobile().subscribe((isMobile) => {
      this.isMobile.set(isMobile);
    });
  }

  ngOnInit(): void {
    this.constantesGlobales = this.configService.getConstantesGlobales();
    const idSeccionCartaDirector = this.constantesGlobales.idCartaDirector;
    const where = "fecha_publicacion < now() and fecha_publicacion >= now() - INTERVAL 1 DAY";
    this.noticiasService.getNoticiasSeccion(idSeccionCartaDirector, 1, "subseccion", where).subscribe((result) => {
      this.noticias.set(result);
    });
  }
}
